var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRehabilitator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6606 32.5071C20.9498 30.634 18.3254 28.0019 16.8786 28.3574C11.4745 29.6854 6 32.3933 6 36.467V43.0003H42V36.467C42 32.3933 36.5255 29.6854 31.1214 28.3574C29.7251 28.0143 27.0937 30.665 25.364 32.5269C25.1309 32.7778 24.9142 33.0144 24.719 33.2274C24.4239 33.5496 24.1782 33.8179 24 34C23.8764 33.8652 23.7191 33.6881 23.5343 33.4803C23.2872 33.2021 22.9909 32.8688 22.6606 32.5071ZM30.857 30.3527C30.7675 30.3895 30.6302 30.4573 30.443 30.5741C29.9445 30.885 29.3342 31.3882 28.6694 32.014C27.7426 32.8867 26.9465 33.7574 26.2964 34.4684C25.9702 34.8252 25.6808 35.1418 25.43 35.3983L23.9528 36.909L22.5254 35.3512C22.377 35.1893 22.2 34.9901 21.9992 34.7644C21.3253 34.0065 20.3843 32.9482 19.3643 31.9878C18.7059 31.3678 18.0997 30.8726 17.6031 30.5689C17.3836 30.4346 17.2435 30.3732 17.1705 30.3457C14.6554 30.9793 12.2542 31.901 10.5162 33.0506C8.69262 34.2569 8 35.4257 8 36.467V41.0003H40V36.467C40 35.4257 39.3074 34.2569 37.4838 33.0506C35.7522 31.9052 33.3622 30.986 30.857 30.3527Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35H36V37H30V35Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 39L32 33L34 33L34 39L32 39Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5C21.7606 5 18.971 5.73846 17.1351 6.32064C16.6753 6.46642 16.4055 6.97763 16.5884 7.4958L18.6122 13.23C22.1994 12.09 25.8006 12.09 29.3878 13.23L31.4116 7.4958C31.5945 6.97763 31.3247 6.46642 30.8649 6.32064C29.029 5.73846 26.2394 5 24 5ZM16.5305 4.41419C18.3904 3.82444 21.431 3 24 3C26.569 3 29.6096 3.82444 31.4694 4.41419C33.0697 4.92161 33.834 6.64176 33.2976 8.16144L30.943 14.8328C30.8536 15.0861 30.6661 15.2928 30.4226 15.4063C30.1792 15.5198 29.9004 15.5306 29.6489 15.4363C25.8753 14.0212 22.1247 14.0212 18.3511 15.4363C18.0996 15.5306 17.8208 15.5198 17.5773 15.4063C17.3339 15.2928 17.1464 15.0861 17.057 14.8328L14.7024 8.16144C14.166 6.64175 14.9303 4.92161 16.5305 4.41419Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8H27V10H21V8Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12L23 6L25 6L25 12L23 12Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7497 14.3701C17.6601 15.6047 17 17.224 17 19C17 22.866 20.134 26 24 26C27.866 26 31 22.866 31 19C31 17.224 30.3399 15.6047 29.2503 14.3701L30.7497 13.0466C32.1495 14.6326 33 16.7182 33 19C33 23.9706 28.9706 28 24 28C19.0294 28 15 23.9706 15 19C15 16.7182 15.8505 14.6326 17.2503 13.0466L18.7497 14.3701Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehabilitator);
export default __webpack_public_path__ + "static/media/rehabilitator.c0497bab4e258f165cfa376ea7db6339.svg";
export { ForwardRef as ReactComponent };